import { Locale } from '@/types/locale';

export interface Configuration {
  readonly newRelicAppId?: string;
  readonly newRelicAccountId?: string;
  readonly newRelicTrustKey?: string;
  readonly newRelicLicenseKey?: string;
  readonly newRelicBeacon?: string;
  readonly newRelicErrorBeacon?: string;
  readonly redirectUri: string;
  readonly keycloakUrl: string;
  readonly logoutUrl: string;
  readonly keycloakClientId: string;
  readonly keycloakRealm: string;
  readonly calizaAPIBaseURL: string;
  readonly clarityProjectId?: string;
  readonly defaultLocale: Locale;
  readonly defaultTimezone: string;
  readonly mock: boolean;
  readonly logRocketAppId: string;
  readonly aipriseTemplateIdBusiness: string;
  readonly aipriseTemplateIdIndividual: string;
  readonly aipriseTemplateCallbackUrlLocal: string;
  readonly aipriseTemplateCallbackUrlDevelop: string;
  readonly aipriseTemplateCallbackUrlSandbox: string;
  readonly aipriseTemplateCallbackUrlProduction: string;
  // Notabene node for the SafeConnect components (Travel Rule ownership proofs).
  // Sandbox default; the production regional node is still to be confirmed
  // (TRAVEL_RULE_FRONTEND_PLAN open question #5).
  readonly notabeneNodeUrl: string;
}

const {
  VITE_CALIZA_CUSTOMER_DASHBOARD_KEYCLOAK_URL,
  VITE_CALIZA_CUSTOMER_DASHBOARD_HOST,
  VITE_CALIZA_CUSTOMER_DASHBOARD_CORE_API_URL,
  VITE_NEWRELIC_APP_ID,
  VITE_NEWRELIC_ACCOUNT_ID,
  VITE_NEWRELIC_TRUST_KEY,
  VITE_NEWRELIC_LICENSE_KEY,
  VITE_NEWRELIC_BEACON,
  VITE_NEWRELIC_ERROR_BEACON,
  VITE_CLARITY_PROJECT_ID,
  VITE_MOCK,
  VITE_AIPRISE_TEMPLATE_ID_BUSINESS,
  VITE_AIPRISE_TEMPLATE_ID_INDIVIDUAL,
  VITE_AIPRISE_TEMPLATE_CALLBACK_URL_LOCAL,
  VITE_AIPRISE_TEMPLATE_CALLBACK_URL_DEVELOP,
  VITE_AIPRISE_TEMPLATE_CALLBACK_URL_SANDBOX,
  VITE_AIPRISE_TEMPLATE_CALLBACK_URL_PRODUCTION,
  VITE_NOTABENE_NODE_URL,
} = import.meta.env;

export const configuration: Configuration = {
  newRelicAppId: VITE_NEWRELIC_APP_ID,
  newRelicAccountId: VITE_NEWRELIC_ACCOUNT_ID,
  newRelicTrustKey: VITE_NEWRELIC_TRUST_KEY,
  newRelicLicenseKey: VITE_NEWRELIC_LICENSE_KEY,
  newRelicBeacon: VITE_NEWRELIC_BEACON,
  newRelicErrorBeacon: VITE_NEWRELIC_ERROR_BEACON,
  calizaAPIBaseURL: VITE_CALIZA_CUSTOMER_DASHBOARD_CORE_API_URL,
  redirectUri: `${VITE_CALIZA_CUSTOMER_DASHBOARD_HOST}/auth/callback`,
  logoutUrl: `${VITE_CALIZA_CUSTOMER_DASHBOARD_HOST ?? ''}/logout`,
  keycloakClientId: 'caliza-customer-dashboard',
  keycloakRealm: 'caliza',
  keycloakUrl: VITE_CALIZA_CUSTOMER_DASHBOARD_KEYCLOAK_URL,
  clarityProjectId: VITE_CLARITY_PROJECT_ID,
  defaultLocale: 'en',
  defaultTimezone: 'America/New_York',
  mock: VITE_MOCK === 'true',
  logRocketAppId: 'hzdska/caliza-dashboard',
  aipriseTemplateIdBusiness: VITE_AIPRISE_TEMPLATE_ID_BUSINESS,
  aipriseTemplateIdIndividual: VITE_AIPRISE_TEMPLATE_ID_INDIVIDUAL,
  aipriseTemplateCallbackUrlLocal: VITE_AIPRISE_TEMPLATE_CALLBACK_URL_LOCAL,
  aipriseTemplateCallbackUrlDevelop: VITE_AIPRISE_TEMPLATE_CALLBACK_URL_DEVELOP,
  aipriseTemplateCallbackUrlSandbox: VITE_AIPRISE_TEMPLATE_CALLBACK_URL_SANDBOX,
  aipriseTemplateCallbackUrlProduction: VITE_AIPRISE_TEMPLATE_CALLBACK_URL_PRODUCTION,
  notabeneNodeUrl: VITE_NOTABENE_NODE_URL ?? 'https://api.eu1.notabene.id',
};
